export default __webpack_public_path__ + "static/iconography-image-c-587dae85f70117ed46141bd8bc8f39146dfc05000d0d657fdef85041be0eb4b6.png";